import React from 'react';
import { formatRut } from '@src/packages/utils/hooks/useRulesByCountry/constants';

const TitleReport = ({ title = '', corporationName = '', rut = '' }) => {
  return (
    <div className="gx-flex-row gx-justify-content-center gx-align-items-center gx-fs-xl">
      <div className="gx-mr-1">{title}</div>
      <div>
        - <span>{corporationName}</span>
        {rut && (
          <span className="gx-text-light-grey gx-font-weight-light"> (RUT {formatRut(rut)}) </span>
        )}
      </div>
    </div>
  );
};

export default TitleReport;
